// extracted by mini-css-extract-plugin
module.exports = {"smaller-heading":"DonateNowForm_smaller-heading__1bXLs","custom-donation-label":"DonateNowForm_custom-donation-label__1aWy6","donate-label":"DonateNowForm_donate-label__27jX5"};